<template>
  <div :class="classList">
    <div
      v-if="overlay"
      class="a-loading-spinner__overlay"
      :class="{ 'a-loading-spinner__overlay--login': login }">
    </div>
    <div class="a-loading-spinner__loader"></div>
  </div>
</template>

<script>
export default {
  name: 'v-loading-spinner',
  props: {
    overlay: {
      type: [Boolean],
      default: true,
    },
    size: {
      type: [String],
      default: 'large',
    },
    login: {
      type: [Boolean],
      default: false,
    },
  },
  computed: {
    classList() {
      const defaultClass = 'a-loading-spinner';
      const size = this.size ? ` a-loading-spinner--${this.size}` : '';
      const overlay = !this.overlay ? ' a-loading-spinner--no-overlay' : '';
      return defaultClass + size + overlay;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.a-loading-spinner';

  #{$parent} {
    // elements
    &__overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.8);
      z-index: 2;
      top: 0px;
      left: 0px;
      &--login {
        top: 0;
        left: 0;
        border-radius: 3px;
      }
    }
    &__loader {
      border-radius: 50%;
      border: 3px solid $signable-primary-1-shade-1;
      border-top-color: $signable-primary-1-shade-2;
      animation: loader 1.5s linear infinite;
      transition: 1s ease;
      z-index: 2;
      @include alignElement(true, true);
    }
    // modifiers
    &--no-overlay {
      #{$parent}__loader {
        position: initial;
        margin: 50px auto 0;
      }
    }
    &--large {
      #{$parent}__loader {
        width: 96px;
        height: 96px;
      }
    }
    &--medium {
      #{$parent}__loader {
        width: 50px;
        height: 50px;
      }
    }
  }

  @keyframes loader {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

</style>
